/**
 * Created by hrachG on 05/18/2018.
 */

import { actionTypes } from './../Constants/constants';
import { ApiUrls, GlobalUrls } from './../Constants/constants';
import { AjaxUtils } from './../utils';
import { AxiosResponse } from 'axios';
import { startLoadingPage, endLoadingPage } from './masterActions';
import { SubmitRequestModel } from "../Models/contactsModel";


export function loadContactsPage() {
    return (dispatch: any, getState: any) => {
        dispatch(startLoadingPage());
        AjaxUtils.axiosGet(ApiUrls.ContactsPage, {}).then((response: AxiosResponse) => {
            dispatch(endLoadingPage());
            if (response != null && response.data != null) {
                dispatch({
                    type: actionTypes.contactsPageDataLoaded,
                     ContactsModel: response.data
                });
            }
            else {
                dispatch({
                    type: actionTypes.contactsPageDataFailedToLoad,
                    ContactsFaliedToLoad: true
                });
            }
        });
    };
}

function SetSubmittingRequest(isSubmitting: boolean)
{
    return (dispatch: any, getState: any) => {
        dispatch({
            type: actionTypes.setSubmittingRequest,
            IsSubmittingRequest: isSubmitting
        });
    };
}

function SetSuccessErrorMessage(successMessage: string, errorMessage: string)
{
    return (dispatch: any, getState: any) => {
        dispatch({
            type: actionTypes.setSuccessMessages,
            SubmitRequestSuccessMessage: successMessage,
            SubmitRequestErrorMessage: errorMessage
        });
    };
}


export function SubmitRequest(model: SubmitRequestModel)
{
    return (dispatch: any, getState: any) => {
        dispatch(SetSubmittingRequest(true));
        AjaxUtils.axiosPost(ApiUrls.SubmitRequest, model, {}).then((response: AxiosResponse) => {
            dispatch(SetSubmittingRequest(false));

            let responseData = response.data;

            let successMessage = "Thank You! Request has been successfully submitted. We'll come back to you as soon as possible.";
            let errorMessage = "Error occured while submitting your request. You send an email to <a href='mailto: info@flexsoftwarecorp.com'>info@flexsoftwarecorp.com</a>"

            if (responseData.success)
            {
                dispatch(SetSuccessErrorMessage(successMessage, null));
            }
            else
            {
                dispatch(SetSuccessErrorMessage(null, errorMessage));
            }

            setTimeout(() => {
                dispatch(SetSuccessErrorMessage(null, null));
            }, 10000);
        });
    };
}


// WEBPACK FOOTER //
// ./ClientApp/app/Actions/contactsActions.tsx